import type { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import type { Action } from '../state/actions.tsx';
import { SET_QUERY } from '../state/query/actions.tsx';
import { getOnQueryChanged } from '../state/query/selectors.tsx';
import type { State } from '../state/reducer.tsx';

export const querySet: Epic<Action, State> = (action$, store) =>
	action$.ofType(SET_QUERY).mergeMap(({ payload }) => {
		const state = store.getState();
		const callback = getOnQueryChanged(state);

		if (typeof callback === 'function') {
			callback(payload);
		}

		return Observable.empty<never>();
	});
